import {DatabaseCode, toDatabaseCode} from "./database-code";

export type ScadaCalcState = DatabaseCode

export const notEligible: ScadaCalcState = {
  code: 'NOT_ELIGIBLE',
  displayValue: {
    id: 'common.entity.scadamode.not_eligible',
    defaultMessage: 'Not Eligible',
  },
};

export const calculated: ScadaCalcState = {
  code: 'CALCULATED',
  displayValue: {
    id: 'common.entity.scadamode.calculated',
    defaultMessage: 'Calculated',
  },
};

export const failedBadData: ScadaCalcState = {
  code: 'FAILED_BAD_DATA',
  displayValue: {
    id: 'common.entity.scadamode.failed_bad_data',
    defaultMessage: 'Failed - Bad Data',
  },
};

export const failedNoDrop: ScadaCalcState = {
  code: 'FAILED_NO_DROP',
  displayValue: {
    id: 'common.entity.scadamode.failed_no_drop',
    defaultMessage: 'Failed - No Drop',
  },
};

export const failedNoData: ScadaCalcState = {
  code: 'FAILED_NO_DATA',
  displayValue: {
    id: 'common.entity.scadamode.failed_no_data',
    defaultMessage: 'Failed - No Data',
  },
};

export const failedInternal: ScadaCalcState = {
  code: 'FAILED_INTERNAL',
  displayValue: {
    id: 'common.entity.scadamode.failed_internal',
    defaultMessage: 'Failed - Internal Error',
  },
};

export const scadaCalcState = {
  notEligible,
  calculated,
  failedBadData,
  failedNoDrop,
  failedNoData,
  failedInternal,
};

export const scadaCalcStates = Object.values(scadaCalcState);

export const toScadaCalcState = (code: string): ScadaCalcState => toDatabaseCode(code, scadaCalcStates);
export const toScadaCalcStateSafely = (code: string | undefined): ScadaCalcState | undefined => code ? toDatabaseCode(code, scadaCalcStates) : undefined;
